import { render, staticRenderFns } from "./vue-wang-editor.vue?vue&type=template&id=f1baa660&scoped=true"
import script from "./vue-wang-editor.vue?vue&type=script&lang=js"
export * from "./vue-wang-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1baa660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1baa660')) {
      api.createRecord('f1baa660', component.options)
    } else {
      api.reload('f1baa660', component.options)
    }
    module.hot.accept("./vue-wang-editor.vue?vue&type=template&id=f1baa660&scoped=true", function () {
      api.rerender('f1baa660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vue-wang-editor.vue"
export default component.exports